import React from 'react';
import { Link } from 'react-router-dom';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { ArrowRight } from 'lucide-react';

const ProductCategories = () => {
  const categories = [
    {
      id: 1,
      name: 'TMT BARS',
      image: '/categories/tmt-bars.png',
      description: 'High-grade TMT reinforcement bars for construction',
    },
    {
      id: 2,
      name: 'PIPES & TUBES',
      image: '/categories/pipes-tubes.png',
      description: 'MS, SS, GI pipes and tubes in various sizes',
    },
    {
      id: 3,
      name: 'STRUCTURAL SECTIONS',
      image: '/categories/structural-sections.jpeg',
      description: 'Angles, channels, beams, and joists',
    },
    {
      id: 4,
      name: 'CRASH BARRIERS',
      image: '/categories/crash-barriers.jpg',
      description: 'Highway safety crash barriers and guards',
    },
    {
      id: 5,
      name: 'MS PLATES',
      image: '/categories/ms-plates.jpg',
      description: 'Mild steel plates in various thicknesses',
    },
    {
      id: 6,
      name: 'SCAFFOLDING & SHUTTERING',
      image: '/categories/scaffolding-shuttering.png',
      description: 'Complete scaffolding and shuttering materials',
    },
    {
      id: 7,
      name: 'BITUMEN & FLY ASH',
      image: '/categories/bitumen-flyash.png',
      description: 'Road construction bitumen and fly ash',
    },
    {
      id: 8,
      name: 'CONSTRUCTION CHEMICALS',
      image: '/categories/construction-chemicals.webp',
      description: 'Concrete admixtures, waterproofing, and more',
    },
    {
      id: 9,
      name: 'GP / HR / CR COILS',
      image: '/categories/coils.jpg',
      description: 'Galvanized, hot rolled, and cold rolled coils',
    },
    {
      id: 10,
      name: 'PAINTS & COATINGS',
      image: '/categories/paints-coatings.webp',
      description: 'Industrial paints and protective coatings',
    },
    {
      id: 11,
      name: 'LRPC STRAND',
      image: '/categories/lrpc-strand.jpg',
      description: 'Pre-stressed concrete strand wires',
    },
    {
      id: 12,
      name: 'RAW MATERIALS',
      image: '/categories/raw-materials.jpg',
      description: 'Scrap, aggregates, and other raw materials',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            WE DEAL IN
          </h2>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-700 mb-4">
            STEEL & STRUCTURAL MATERIALS
          </h3>
          <h3 className="text-2xl md:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-secondary-500 to-secondary-600">
            CONSTRUCTION CHEMICALS
          </h3>
          <div className="mt-6 inline-block bg-gradient-to-r from-secondary-500 to-secondary-600 px-8 py-3 rounded-full">
            <p className="text-white font-semibold">
              Pan-India Supply | Reliable Sourcing | On-Time Delivery
            </p>
          </div>
        </div>

        {/* Categories Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-12">
          {categories.map((category, index) => (
            <Card
              key={category.id}
              hover
              padding="none"
              className="group overflow-hidden animate-slide-up"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              {/* Category Image */}
              <div className="relative h-40 overflow-hidden bg-gray-100">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                {/* Category Name Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="text-white text-lg font-bold text-center">
                    {category.name}
                  </h3>
                </div>
              </div>

              {/* Category Description */}
              <div className="p-4 bg-gradient-to-br from-secondary-50 to-secondary-100">
                <p className="text-sm text-gray-700 text-center">
                  {category.description}
                </p>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center animate-fade-in">
          <Link to="/products">
            <Button
              variant="secondary"
              size="lg"
              rightIcon={<ArrowRight className="w-5 h-5" />}
            >
              View All Products
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductCategories;
